import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Nav from '../../components/tvNav';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SubNav from '../../components/SubNav';
import ToTop from '@ifeng-fe/container_channel/common/client/components/toTop';

const Contact = errorBoundary(props => {
    return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
});

const PriceList = errorBoundary(props => {
    return (
        <div className={styles.ad_container}>
            {props.content.map((item, index) => {
                return (
                    <div className={styles.ad_item} key={index}>
                        <div className={styles.img_container}>
                            <img src={item.src} />
                        </div>
                        <div className={styles.ad_title}>
                            <a href={item.url} target="_blank">
                                {item.title}
                            </a>
                        </div>
                    </div>
                );
            })}
        </div>
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { footer, headerNav, day, date, search, footerNav, leftNav, contact, priceList },
        } = this.props;

        const { content } = this.props;
        // 头部
        const headerData = {
            // nav: content.nav,
            nav: { ...content.nav, limit: 17 },
            topAd: content.topAd,
            search: content.search,
            logo: content.logo,
        };
        const footerData = {
            footerNav: content.footerNav,
            footerCopyright: content.footerCopyright,
        };

        return (
            <div className={styles.phtv_container}>
                <div className={styles.headerWrap}>
                    <Header content={headerData} />
                </div>
                <Chip id="230203" type="struct" title="凤凰卫视-首页子导航" groupName="正文" content={content.subNav}>
                    <SubNav theme={styles.subNav} active={content.paramName} />
                </Chip>
                <div className={styles.phtv_body}>
                    <Chip id="170113" type="struct" title="导航" groupName="nav" content={leftNav}>
                        <Nav type={1} />
                    </Chip>
                    <div className={styles.content}>
                        <div className={styles.title_img} />
                        <div className={styles.small_title} />
                        <Chip id="200096" type="struct" title="价目表" groupName="content" content={priceList}>
                            <PriceList />
                        </Chip>
                        <Chip id="130269" type="static" title="联系方式" groupName="content" content={contact}>
                            <Contact />
                        </Chip>
                    </div>
                </div>
                <div className={styles.footerWrap}>
                    <Footer content={footerData} />
                </div>
                <ToTop windowMode="normal" />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
